module.exports = __webpack_public_path__ + "static/media/sdk-3.d983b066.svg";